module.exports = "/_next/static/images/ae72cc7b127422efcb30f5f1b2922791-cuenta-card-lg.png.webp";